import { RouteConfig } from 'vue-router'
import { conversationAIRouteNames } from '../constants/location'
import { voiceAIRouteNames } from '../constants/location'
import { knowledgeBaseRouteNames } from '../constants/location'
import { requireAuthAndLocation } from '../auth'
import EmptyRouterParent from '../../pmd/pages/EmptyRouterParent.vue'
import { agentStudioRouteNames } from '../constants/location/agentStudio'
const AIEmployeePromo = () =>
  import(
    /* webpackChunkName: "ai-employee-promo-location" */ '@/apps/aiEmployeePromo/aiEmployeePromoLocation.vue'
  ).then(m => m.default)

const AIAgentsContestLocation = () =>
  import(
    /* webpackChunkName: "ai-agents-contest-location" */ '@/apps/aiEmployeePromo/aiAgentsContestLocation.vue'
  ).then(m => m.default)

const AIAgentsGettingStarted = () => import('@/apps/aiEmployeePromo/AIAgentsGettingStarted.vue').then(m => m.default)
const ConversationAiSettingsV2 = () => import('@/apps/conversations/settings/aiV2.vue').then(m => m.default)
const KnowledgeBaseSettings = () => import('@/apps/knowledgeBase/settings/knowledgeBase.vue').then(m => m.default)
const VoiceAiSettings = () => import('@/apps/voice/settings/ai.vue').then(m => m.default)
const AgentStudio = () => import('@/apps/agentStudio/settings/agentStudio.vue').then(m => m.default)
const contentAIPage = () => import('@/pmd/pages/content_ai/ContentAIPage.vue').then(m => m.default)
const AgentTemplates = () => import('@/apps/aiEmployeePromo/AgentTemplates.vue').then(m => m.default)

export const aiEmployeePromoRoute: RouteConfig[] = [
  {
    path: 'ai-employee-promo',
    name: conversationAIRouteNames.aiEmployeePromoLocation,
    component: AIEmployeePromo,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'ai-agents-contest',
    name: conversationAIRouteNames.aiAgentsContestLocation,
    component: AIAgentsContestLocation,
    beforeEnter: requireAuthAndLocation,
  },
  {
    path: 'ai-agents',
    component: EmptyRouterParent,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: 'getting-started',
        name: conversationAIRouteNames.aiAgentsGettingStarted,
        component: AIAgentsGettingStarted,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'voice-ai',
        name: conversationAIRouteNames.aiAgentsVoiceAi,
        component: VoiceAiSettings,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: '',
            name: voiceAIRouteNames.aiAgentsVoiceAiHome,
            component: VoiceAiSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: ':agentId',
            name: voiceAIRouteNames.aiAgentsVoiceAiEditAgent,
            component: VoiceAiSettings,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'conversation-ai',
        name: conversationAIRouteNames.aiAgentsConversationAi,
        component: ConversationAiSettingsV2,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: '',
            name: conversationAIRouteNames.conversationAISettingsV2Default,
            component: ConversationAiSettingsV2,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'create-agent',
            name: conversationAIRouteNames.conversationAISettingsV2CreateAgent,
            component: ConversationAiSettingsV2,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'create-agent-fmb',
            name: conversationAIRouteNames.conversationAISettingsV2CreateAgentFmb,
            component: ConversationAiSettingsV2,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'agent/:agentId',
            name: conversationAIRouteNames.conversationAISettingsV2EditAgent,
            component: ConversationAiSettingsV2,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'agent-studio',
        name: agentStudioRouteNames.aiAgentsAgentStudio,
        component: AgentStudio,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'agent/:agentId',
            name: agentStudioRouteNames.agentStudioAgentVersionManager,
            component: AgentStudio,
            beforeEnter: requireAuthAndLocation,
          },
          {
            // New route: versionId via query param (?v=versionId)
            path: 'agent/:agentId/edit',
            name: agentStudioRouteNames.agentStudioFlowEditor,
            component: AgentStudio,
            beforeEnter: requireAuthAndLocation,
          },
          {
            // Legacy route: versionId in path (kept for backward compatibility)
            path: 'agent/:agentId/versions/:versionId/edit',
            name: agentStudioRouteNames.agentStudioFlowEditorLegacy,
            component: AgentStudio,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'content-ai',
        name: conversationAIRouteNames.aiAgentsContentAi,
        component: contentAIPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'knowledge-base',
        name: knowledgeBaseRouteNames.aiAgentsKnowledgeBase,
        component: KnowledgeBaseSettings,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: ':knowledgeBaseId',
            name: knowledgeBaseRouteNames.editKnowledgeBase,
            component: KnowledgeBaseSettings,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'agent-templates',
        name: conversationAIRouteNames.aiAgentsAgentTemplates,
        component: AgentTemplates,
        beforeEnter: requireAuthAndLocation,
      },
    ],
  },
]
